import React from 'react';
import { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import QuestionMark from '../../../../assets/images/svg/question-blue-icon.svg';
import sample from '../../../../assets/images/placeholders/sample.svg';
import { ProductListingContext } from '../../functions/data_formatting_functions';
import { actionSetListingData } from '../../store/create_listing_actions';
import { Label } from '../../../../styles/style';
import ShowImage from '../../../../components/show_image';
import Error from '../../../../components/error';
import AddPhotosModal from '../media/modals/add_photos_modal';
import { useTable } from 'react-table';
import { toast } from 'react-toastify';
import { CURRENT_CURRENCY } from '../../../../config/constants';
import { S3ApiRepository } from '../../../../data/repositories/s3_repository';
import { ApiRepository } from '../../../../data/repositories/base_repository';
import {
  ListingState,
  TableCombination,
} from '../../../../data/types/listings';
import { ImageType } from '../../../../data/types/files';
import { Colors } from '../../../../config/theme';
import { Select } from 'antd';
import { Button, Checkbox } from '@nextui-org/react';

type CombinationsTableProps = {
  addStep: () => void;
  remove: () => void;
  currentStore: any;
  s3Repository: S3ApiRepository;
  filesRepository: ApiRepository;
};

enum BulkValueType {
  price = 0,
  validity = 1,
  stock = 2,
}

function CombinationsTable({
  addStep,
  remove,
  currentStore,
  s3Repository,
  filesRepository,
}: CombinationsTableProps) {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: any;
  } = useContext(ProductListingContext);

  const [sideBar, SetSideBar] = useState(false);
  const [selectedCombIndex, setSelectCombIndex] = useState(0);
  const [combinations, setCombinations] = useState<TableCombination[]>([]);
  const [same_attributes, setSameAttributes] = useState<string[]>([]);
  const [currently_selected_image, setCurrentlySelectedImage] =
    useState<ImageType>();

  const [bulkSelected, setBulkSelected] = useState(false);
  const [bulkValidSelected, setBulkValidSelected] = useState(false);
  const [bulkInStockSelected, setBulkInStockSelected] = useState(false);
  const [currentBulkValue, setCurrentBulkValue] = useState('');
  const [currentBulkChange, setCurrentBulkChange] = useState(
    BulkValueType.price,
  );
  const [
    currentSelectedBulkCombinationsIndicies,
    setCurrentSelectedBulkCombinationsIndicies,
  ] = useState<Set<number>>(new Set());

  // Due to internal state setting, if an image is imported using from the relevant Attribute, it cannot be changed (search for if (matchingAttribute && !changedAttributeImage[matchingAttribute]) in the code below), so, we set this flag to true in case it has already been set to prevent the image from being RE-SET to attribute image.

  const variables = state.all_attributes
    .filter(
      (attr) =>
        (attr.is_variable &&
          (!attr.values || attr.values.length === 0) &&
          attr?.values_en!.length > 0) ||
        (attr.is_variable &&
          (!attr.values_en || attr.values_en.length === 0) &&
          attr?.values!.length > 0),
    )
    .map((attr) => attr.name_en);

  const priceRef = useRef(null);
  const [errors, setErrors] = useState({
    price: '',
  });

  let showCombinations: any =
    // state.all_attributes.length > 1 ||
    state.all_attributes.filter(
      (attr) =>
        (attr.is_variable &&
          (!attr.values || attr.values.length === 0) &&
          attr?.values_en!.length > 0) ||
        (attr.is_variable &&
          (!attr.values_en || attr.values_en.length === 0) &&
          attr?.values!.length > 0),
    );

  if (showCombinations.length === 0) {
    showCombinations = false;
  }

  console.log('combinations screen state: ', state);

  useEffect(() => {
    if (bulkSelected) {
      const updated = new Set(
        Array.from({ length: combinations.length }, (_, i) => i),
      );
      setCurrentSelectedBulkCombinationsIndicies(updated);
    } else {
      setCurrentSelectedBulkCombinationsIndicies(new Set());
    }
  }, [bulkSelected]);

  useEffect(() => {
    const updatedCombinations = combinations;
    if (bulkValidSelected) {
      updatedCombinations.map((e) => {
        e.valid = true;
      });
    } else {
      updatedCombinations.map((e) => {
        e.valid = false;
      });
    }
    setCombinations(updatedCombinations.map((e) => e));
  }, [bulkValidSelected]);

  useEffect(() => {
    const updatedCombinations = combinations;
    if (bulkInStockSelected) {
      updatedCombinations.map((e) => {
        e.in_stock = true;
      });
    } else {
      updatedCombinations.map((e) => {
        e.in_stock = false;
      });
    }
    setCombinations(updatedCombinations.map((e) => e));
  }, [bulkInStockSelected]);

  useEffect(() => {
    dispatch(
      actionSetListingData({
        ...state.data,
        combinations_table: combinations,
      }),
    );
  }, [combinations]);

  useEffect(() => {
    if (showCombinations) {
      if (state.data.combinations_table?.length < 1) {
        createCombinations();
      } else {
        let total = 1;

        const same_attr = state.all_attributes
          ?.filter((attr) => {
            if (attr.is_variable) {
              console.log('this is attr', attr);
              if (attr.values) total *= attr.values.length;
              else total *= attr.values_en!.length;
            }
            return attr.is_variable;
          })
          ?.map((attr) => attr.name_en);
        let count = 0;
        console.log(same_attr);
        same_attr.forEach((same) => {
          return Object.keys(state.data.combinations_table[0].attrs).forEach(
            (comb_attr) => {
              if (comb_attr === same) {
                count++;
              }
            },
          );
        });
        console.log(
          'this is all',
          total,
          same_attr,
          count,
          state.data.combinations_table,
          state.all_attributes,
        );
        if (
          count !==
          state.all_attributes?.filter((attr) => attr.is_variable).length
        ) {
          createCombinations();
        } else {
          setSameAttributes(same_attr);
          let filtered_combinations = state.data.combinations_table;
          if (total != state.data.combinations_table.length) {
            const pre_filtered_combinations = createCombinations(false);
            filtered_combinations = filterCombinations(
              pre_filtered_combinations,
            );
          }
          setCombinations(filtered_combinations);
          console.log("I'm HERE BITCHJES", same_attr);
        }
      }
    }
  }, []);

  const attributeNotMultiple = (key: string) => {
    state.all_attributes.forEach((attr) => {
      if (attr.name_en === key) {
        return attr.is_variable;
      }
    });
    return false;
  };

  const handleInputFocus = () => {
    if (priceRef.current) {
      // priceRef.current.focus();
    }
  };

  const filterCombinations = (pre_filtered_combinations: any) => {
    const filtered_combinations: any = [];
    //checks which of the state.data.combinations_table are in the pre_filtered_combinations
    console.log(
      'pre',
      pre_filtered_combinations,
      state.data.combinations_table,
    );
    pre_filtered_combinations.forEach((pre_combination: any) => {
      let result: any = undefined;
      state.data.combinations_table.forEach((combination) => {
        const arr = Object.keys(combination.attrs);
        let is_same = true;

        if (!result) {
          console.log('result', pre_combination, combination);
          arr.forEach((key: any) => {
            if (
              pre_combination.attrs[key] &&
              combination.attrs[key] &&
              pre_combination.attrs[key].toString() !==
                combination.attrs[key].toString()
            ) {
              if (attributeNotMultiple(key)) {
                combination.attrs[key] = pre_combination.attrs[key];
              } else {
                is_same = false;
                console.log(
                  'different attribute',
                  pre_combination.attrs[key],
                  combination.attrs[key],
                );
              }
            }
          });
          console.log(is_same);
          if (is_same) {
            result = combination;
          }
        }
      });
      if (result) {
        filtered_combinations.push(result);
      } else {
        filtered_combinations.push(pre_combination);
      }
    });
    console.log(filtered_combinations);
    return filtered_combinations;
  };

  const createCombinations = (bool = true) => {
    console.log('allllllll', state.all_attributes);
    const combinationsList: any = [];
    const same_attr = state.all_attributes
      ?.filter((attr) => attr.custom || attr.is_variable)
      ?.map((attr) => attr.name_en);
    setSameAttributes(same_attr);
    // checking how many combination will be created
    const variable_attributes: any = [];
    state.all_attributes
      ?.filter((attr) => attr.is_variable)
      .forEach((main_attr) => {
        console.log('this is main', main_attr);
        if (main_attr.custom || main_attr.is_variable) {
          if (main_attr.values_en && main_attr.values_en?.length > 0)
            variable_attributes.push(main_attr.values_en);
          else variable_attributes.push(main_attr.values);
        }
      });
    console.log('the variable attrs are', variable_attributes);
    const variations_results = createVariations(variable_attributes, '');
    if (variations_results) {
      variations_results?.forEach((variation: any) => {
        const attr_obj: any = {};
        same_attr?.forEach((attr, index) => {
          console.log('this is var', attr, variation);
          const value =
            variation?.trim()?.split(' ').length > 0
              ? variation?.trim().split(' ')[index]?.replaceAll('_', ' ')
              : variation?.trim();
          attr_obj[attr] = value;
        });

        const matchingAttribute = Object.keys(attr_obj).find((attribute) => {
          return (
            state.data.selectedImages[attribute] &&
            state.data.selectedImages[attribute][
              attr_obj[attribute as keyof typeof attr_obj]
            ] !== undefined
          );
        });
        if (matchingAttribute) {
          const id =
            state.data.selectedImages[matchingAttribute][
              attr_obj[matchingAttribute as keyof typeof attr_obj]
            ];
          if (!state.data.notToUploadImages.includes(id)) {
            (attr_obj as any).image_id = id;
          }
        }

        const originalCombination = state.data.prev_combinations_table?.find(
          (comb) => {
            console.log('Comb', comb.attrs, attr_obj);
            return Object.keys(comb.attrs).every((key) => {
              const combValue = (comb.attrs as { [key: string]: any })[key];
              const attrValue = attr_obj[key];

              // Don't check key if it doesn't exist in the attribute object
              if (!attrValue) {
                return true;
              }

              // Convert numeric-like strings to numbers for comparison
              if (!isNaN(combValue) && !isNaN(attrValue)) {
                return parseFloat(combValue) === parseFloat(attrValue);
              }
              // Default to strict equality check for non-numeric values
              return combValue === attrValue;
            });
          },
        );
        combinationsList.push({
          valid: originalCombination?.valid || false,
          in_stock: originalCombination?.in_stock || false,
          attrs: { ...attr_obj },
          price: originalCombination?.price || '',
          image_id: originalCombination?.image_id || null,
          ...attr_obj, // Spread attr_obj properties directly
        });
      });
    }
    if (bool) {
      setTimeout(() => {
        setCombinations(combinationsList);
      }, 1000);
    } else {
      return combinationsList;
    }
  };

  const updateMyData = (rowIndex: any, value: any) => {
    // We also turn on the flag to not reset the page
    // setSkipPageReset(true);
    updatePrice(value, rowIndex);
  };

  const handleValidations = () => {
    const errorsFields = {
      price: '',
    };
    let error = false;
    if (state.data?.combinations_table?.length > 0) {
      if (
        state.data?.combinations_table?.filter((com) => com.valid).length < 1
      ) {
        toast.warning('Please select at least one item as valid to continue');
        error = true;
      }
      const result = state.data?.combinations_table?.filter(
        (com) => !com.price && com.valid,
      );
      if (result.length > 0) {
        toast.warning('Please enter price for every combination');
        error = true;
      }
    } else {
      Object.keys(state.data).map(function (keyName: any) {
        const value = state.data[keyName as keyof typeof state.data];
        if (keyName === 'price') {
          if (!value) {
            errorsFields.price = 'ⓘ Price is required.';
            error = true;
          }
        }
      });
    }
    setErrors(errorsFields);
    return error;
  };

  const get_image = (imageId: number) => {
    return state.data?.imagesList?.filter((img) => img.id === imageId)[0];
  };

  const createVariations = (arr: any, pre: any) => {
    pre = pre || '';
    if (!arr.length) {
      return pre;
    }
    const ans = arr[0].reduce(function (ans: any, value: any) {
      const val = value.toString();
      return ans.concat(
        createVariations(arr.slice(1), pre + ' ' + val?.replace(/ /g, '_')),
      );
    }, []);
    return ans;
  };

  const openImageSelection = (index: number, image_id: number) => {
    setSelectCombIndex(Number(index));
    setCurrentlySelectedImage(
      state.data.imagesList.filter((img) => img.id === image_id)[0],
    );
    SetSideBar(true);
  };

  const updateBulks = (i: any) => {
    const index = parseInt(i);
    if (currentSelectedBulkCombinationsIndicies.has(index)) {
      currentSelectedBulkCombinationsIndicies.delete(index);
      setCurrentSelectedBulkCombinationsIndicies(
        currentSelectedBulkCombinationsIndicies,
      );
    } else {
      const updated = currentSelectedBulkCombinationsIndicies.add(index);
      setCurrentSelectedBulkCombinationsIndicies(updated);
    }
    setCombinations(combinations.filter((comb) => comb));
  };

  const updatePrice = (value: number, index: number) => {
    combinations[index].price = value;
    setCombinations(combinations.filter((comb) => comb));
  };

  const updateIsValid = (index: number) => {
    // setSkipPageReset(true);
    combinations[index].valid = !combinations[index].valid;
    setCombinations(combinations.filter((comb) => comb));
  };

  const updateIsStock = (index: number) => {
    // setSkipPageReset(true);
    combinations[index].in_stock = !combinations[index].in_stock;
    setCombinations(combinations.filter((comb) => comb));
  };

  const doneCombinations = () => {
    dispatch(
      actionSetListingData({ ...state.data, combinations_table: combinations }),
    );
    if (!handleValidations()) {
      return addStep();
    }
  };

  const saveCombinationsAsPrev = () => {
    dispatch(
      actionSetListingData({
        ...state.data,
        prev_combinations_table: combinations,
      }),
    );
  };

  const addImagesToVariation = (image: ImageType) => {
    combinations.map((comb, index) => {
      if (index === selectedCombIndex) {
        comb.image_id = image.id;
      }
    });
    setCombinations(combinations.filter((comb) => comb));
    SetSideBar(false);
    setCurrentlySelectedImage(undefined);
  };

  const handleCancel = () => {
    SetSideBar(false);
    setCurrentlySelectedImage(undefined);
  };

  function RenderTable({ columns, data }: { columns: any; data: any }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
        // updateIsValid,
        // updatePrice,
        // updateMyData,
      });

    return (
      <div className="scroll">
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, j) => {
                  const headerContent = column.render('Header');
                  return (
                    <th {...column.getHeaderProps()} key={j}>
                      {typeof headerContent === 'bigint'
                        ? (headerContent as any).toString()
                        : headerContent}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  key={i}
                  style={{
                    backgroundColor: (row?.original as TableCombination)?.valid
                      ? Colors.white
                      : Colors.greySecondary,
                    textDecoration: (row?.original as TableCombination)?.valid
                      ? 'none'
                      : 'line-through',
                  }}
                >
                  {row.cells.map((cell) => {
                    const cellContent = cell.render('Cell');
                    return (
                      custom_cells(cell, row) || (
                        <td
                          {...cell.getCellProps()}
                          key={row.id + cell.column.id}
                          style={{
                            fontSize: '15px !important',
                          }}
                        >
                          {typeof cellContent === 'bigint'
                            ? (cellContent as any).toString()
                            : cellContent}
                        </td>
                      )
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const EditableCell = ({
    value: initialValue,
    row: { values, index },
  }: {
    value: any;
    row: any;
  }) => {
    const [value, setValue] = React.useState(initialValue);
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
    };
    const onBlur = () => {
      updateMyData(index, value);
    };
    React.useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);
    return (
      <input
        type="number"
        // onWheel={(e) => e.target.blur()}
        className="price"
        placeholder="₪1000"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={values.valid ? false : true}
        onFocus={handleInputFocus}
      />
    );
  };

  function applyBulkEdit() {
    const updatedCombinations = combinations?.map((i, index: number) => {
      if (currentSelectedBulkCombinationsIndicies.has(index)) {
        if (currentBulkChange === BulkValueType.price) {
          i.price = parseFloat(currentBulkValue);
        } else if (currentBulkChange === BulkValueType.validity) {
          i.valid = currentBulkValue === 'true';
        } else {
          i.in_stock = currentBulkValue === 'true';
        }
      }
      return i;
    });
    setCurrentBulkValue('');
    setCombinations(updatedCombinations);
    // setCurrentSelectedBulkCombinationsIndicies(new Set());
  }

  function custom_cells(cell: any, row: any) {
    if (cell.column.id === 'bulk') {
      return (
        <td key={row.id + cell.column.id} onClick={() => updateBulks(row.id)}>
          <input
            className="form-check-input"
            type="checkbox"
            id={`bulk${row.id}`}
            defaultChecked={currentSelectedBulkCombinationsIndicies.has(
              parseInt(row.id),
            )}
          />
        </td>
      );
    }
    if (cell.column.id === 'valid') {
      return (
        <td key={row.id + cell.column.id} onClick={() => updateIsValid(row.id)}>
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id={`valid${row.id}`}
            defaultChecked={cell.value}
          />
        </td>
      );
    }
    if (cell.column.id === 'in_stock') {
      return (
        <td key={row.id + cell.column.id} onClick={() => updateIsStock(row.id)}>
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id={`in_stock${row.id}`}
            defaultChecked={cell.value}
            disabled={!row.values.valid ? true : false}
          />
        </td>
      );
    }
    if (cell.column.Header === `Price ${String(CURRENT_CURRENCY)}`) {
      return (
        <td {...cell.getCellProps()} key={row.id + cell.column.id}>
          {cell.render(() =>
            EditableCell({
              value: cell.value,
              row: row,
            }),
          )}
        </td>
      );
    }
    if (cell.column.Header === 'Image') {
      return (
        <td
          key={row.id + ' ' + cell.column.id}
          onClick={() => {
            if (row.values.valid) {
              openImageSelection(row.id, row.values.image_id);
            }
          }}
        >
          {row.values.image_id ? (
            <ShowImage
              style={{ width: '150px', height: '60px' }}
              image={get_image(row.values.image_id)}
            />
          ) : (
            <img src={sample} alt="..." />
          )}
        </td>
      );
    }
  }

  const columns = React.useMemo(
    () => [
      {
        Header: (
          <div>
            Bulk
            <div style={{ width: '10px' }} />
            <input
              className="form-check-input"
              type="checkbox"
              id="bulk"
              onChange={(e) => {
                setBulkSelected(e.target.checked ? true : false);
              }}
            />
          </div>
        ),
        accessor: 'bulk',
      },
      {
        Header: (
          <div>
            Valid
            <div style={{ width: '10px' }} />
            <input
              className="form-check-input"
              type="checkbox"
              id="valid"
              onChange={(e) => {
                setBulkValidSelected(e.target.checked ? true : false);
              }}
            />
          </div>
        ),
        accessor: 'valid',
      },
      ...same_attributes
        .filter((att) => variables.includes(att))
        .map((attr) => {
          return {
            Header: attr,
            accessor: attr,
          };
        }),
      { Header: `Price ${CURRENT_CURRENCY}`, accessor: 'price' },
      { Header: 'Image', accessor: 'image_id' },
      {
        Header: (
          <div>
            In Stock
            <div style={{ width: '10px' }} />
            <input
              className="form-check-input"
              type="checkbox"
              id="bulk"
              onChange={(e) => {
                setBulkInStockSelected(e.target.checked ? true : false);
              }}
            />
          </div>
        ),
        accessor: 'in_stock',
      },
    ],
    [same_attributes],
  );
  const data = React.useMemo(
    () => [
      ...combinations.map((combination) => {
        let current_state: any = { valid: combination.valid };
        same_attributes?.map((attr: string) => {
          if (variables.includes(attr)) {
            current_state[attr] =
              combination[attr as keyof typeof combination]?.toString() || '';
          }
        });
        current_state = {
          ...current_state,
          price: combination.price,
          image_id: combination.image_id,
          in_stock: combination.in_stock,
        };
        return current_state;
      }),
    ],
    [combinations],
  );

  return (
    <SpecificationsStyle>
      <div className="unscrollable">
        {showCombinations ? (
          <div className="row-3">
            <h3>
              Combination Table
              <img className="question" src={QuestionMark} alt="..." />{' '}
            </h3>
            <hr />
            <p>All Combinations of attributes that have multiple values</p>
            <div className="set-value">
              <p>
                If many items share the same values you may do bulk update:
                <li>
                  Select what you want to change: Price / Validity / Stock
                </li>
                <li>Set the value you want</li>
                <li>Click Apply to selected</li>
              </p>
              <div className="inputs">
                <div
                  className="value-input"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                    marginBottom: '10px',
                  }}
                >
                  <p>Changing</p>
                  <div style={{ width: '10px' }} />
                  <Select
                    value={currentBulkChange}
                    options={[
                      { label: 'Price', value: BulkValueType.price },
                      { label: 'Valid', value: BulkValueType.validity },
                      { label: 'Stock', value: BulkValueType.stock },
                    ]}
                    style={{
                      width: '150px',
                    }}
                    onChange={(value: any) => {
                      setCurrentBulkChange(value);
                      // setCurrentSelectedBulkCombinationsIndicies(new Set());
                    }}
                  />

                  <div style={{ width: '10px' }} />
                  <input
                    className={
                      currentBulkChange === BulkValueType.price
                        ? 'bulk-price'
                        : 'form-check-input'
                    }
                    width={50}
                    placeholder="Bulk Price"
                    style={{
                      border: '1px grey',
                    }}
                    value={currentBulkValue}
                    onChange={(e) => {
                      if (currentBulkChange === BulkValueType.price) {
                        setCurrentBulkValue(e.target.value);
                      } else {
                        setCurrentBulkValue(
                          e.target.checked ? 'true' : 'false',
                        );
                      }
                    }}
                    type={
                      currentBulkChange === BulkValueType.price
                        ? 'number'
                        : 'checkbox'
                    }
                  />

                  <div style={{ width: '10px' }} />
                  <Button color="success" onClick={() => applyBulkEdit()}>
                    Apply to selected
                  </Button>
                </div>
              </div>
            </div>

            <RenderTable columns={columns} data={data} />
          </div>
        ) : (
          <div className="col-md-8 bg-white ">
            <h3>Combinations</h3>
            <hr />
            <p>Simple listing price & stock info</p>
            <div className="mx-2 mt-4" style={{ margin: '10px' }}>
              <Label color="#00273380">STOCK</Label>
              <div className="table_stock">
                <div // <Icon
                  className="checkBoxes d-flex"
                  style={{ display: 'flex' }}
                >
                  <Checkbox
                    isSelected={state.data.in_stock}
                    onChange={(e) => {
                      dispatch(
                        actionSetListingData({
                          ...state.data,
                          in_stock: e.target.checked,
                        }),
                      );
                    }}
                  >
                    In Stock
                  </Checkbox>
                </div>
                <div className="position-relative info-hover text-start">
                  <div className="info-sign poppins text-white center">?</div>
                  <div className="info-div">
                    Set whether the product is in stock or not.
                  </div>
                </div>
              </div>
            </div>

            <div className="mx-2 mt-4">
              <Label color="#00273380">PRICE</Label>
              <div className="table_stock">
                <div className="price">
                  <input
                    placeholder="1000₪"
                    type="number"
                    value={state.data.price}
                    onChange={(e) => {
                      dispatch(
                        actionSetListingData({
                          ...state.data,
                          price: e.target.value,
                        }),
                      );
                    }}
                    name="price"
                    style={{
                      border: '1px solid var(--secondary-color)',
                      padding: '5px',
                    }}
                  />
                  <br />

                  <br />
                  {errors.price ? <Error text={errors.price} /> : ''}
                </div>

                <div className="position-relative info-hover text-start">
                  <div className="info-sign poppins text-white center">?</div>
                  <div className="info-div">
                    Choose the price of the product.
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <AddPhotosModal
          currentStore={currentStore}
          isModalVisible={sideBar}
          setPhotoBarModal={SetSideBar}
          selection={true}
          addImagesToVariation={addImagesToVariation}
          handleCancel={handleCancel}
          selectedImage={currently_selected_image}
          s3Repository={s3Repository}
          filesRepository={filesRepository}
          addOrSelectActionsOnly={true}
        />
      </div>
      <div className=" butns mt-4">
        <Button onClick={remove} color="success" variant="bordered">
          Back
        </Button>
        <Button
          color="success"
          variant="flat"
          onClick={saveCombinationsAsPrev}
          style={{
            width: '150px',
          }}
        >
          Save
        </Button>
        <Button
          color="success"
          onClick={doneCombinations}
          style={{
            width: '150px',
          }}
        >
          Next step
        </Button>
      </div>
    </SpecificationsStyle>
  );
}

export default CombinationsTable;

const SpecificationsStyle = styled.div`
  .unscrollable {
    overflow-x: auto;
    width: 100%;
  }
  font-family: 'Lato';
  font-style: normal;
  .scroll {
    max-width: 80vw;
    white-space: nowrap;
  }
  table {
    border-collapse: collapse;
  }
  .form-check-input:checked {
    background-color: #05ae4b;
  }

  .price {
    border: none;
    border-radius: 5px;
    width: 55px;
    padding: 2px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
  thead {
    background: #f2f4f5;
    box-shadow: 0px 1px 1px rgba(0, 39, 51, 0.25);
    font-weight: 700;
    font-size: 13px;
    color: #002733;
  }

  p {
    font-weight: 600;
    font-size: 12px;
    color: rgba(0, 39, 51, 0.5);
    margin: 10px;
  }
  tbody {
    background: rgba(220, 238, 221, 0.5);
    font-size: 15px;
    color: #002733;
    tr {
      :hover {
        background: rgba(90, 179, 168, 0.15);
      }
    }
  }
  th,
  td {
    padding: 5px;
    font-size: 13px;
    width: 200px;
    text-align: center;
    // word-break: break-all;
    padding: 15px;
  }
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #002733;
    margin: 10px;
  }
  .question {
    padding-left: 3px;
  }
  .back {
    border: 1px solid #05ae4b;
    border-radius: 5px;
  }
  .butns {
    margin: 20px 0px;
    display: flex;
    justify-content: space-between;
  }
  .bg-white {
    background-color: white;
    padding: 10px;
  }
  .table_stock {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  .position-relative {
    position: relative;
  }
  .text-start {
    text-align: start;
  }
  .text-white {
    color: white;
  }
`;
